module.exports = __webpack_public_path__ + "static/media/1.1fc1b69e.png";